import { render, staticRenderFns } from "./file-upload.vue?vue&type=template&id=3195c972&scoped=true"
import script from "./file-upload.vue?vue&type=script&lang=js"
export * from "./file-upload.vue?vue&type=script&lang=js"
import style0 from "./file-upload.vue?vue&type=style&index=0&id=3195c972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3195c972",
  null
  
)

export default component.exports